import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { theme } from "./common/themesConfig";
// import Layout from "./common/layout/LayoutThree";
import NotFound from "./common/components/NotFound";
// GBS 3.0
import Home from "./pages/Home";
import DayOne from "./pages/gbs_3.0/DayOne";
import DayTwo from "./pages/gbs_3.0/DayTwo";
import DayThree from "./pages/gbs_3.0/DayThree";
import LayoutThree from "./common/layout/LayoutThree";
import LayoutFour from "./common/layout/LayoutFour";
import LayoutFive from "./common/layout/LayoutFive";

// GBS 4.0
import FourDayOne from "./pages/gbs_4.0/DayOne";
import FourDayTwo from "./pages/gbs_4.0/DayTwo";
import FourDayThree from "./pages/gbs_4.0/DayThree";
import FourHome from "./pages/gbs_4.0/Home";
import FiveHome from "./pages/gbs_5.0/Home";
import FiveDayOne from "./pages/gbs_5.0/DayOne";
import FiveDayTwo from "./pages/gbs_5.0/DayTwo";
import FiveDayThree from "./pages/gbs_5.0/DayThree";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route element={<LayoutFive />}>
            <Route path="/" element={<FiveHome />} />
            <Route path="/day-one" element={<FiveDayOne />} />
            <Route path="/day-two" element={<FiveDayTwo />} />
            <Route path="/day-three" element={<FiveDayThree />} />
            <Route path="*" element={<NotFound version="5.0" />} />
          </Route>
          <Route element={<LayoutFour />}>
            <Route path="/4.0" element={<FourHome />} />
            <Route path="/4.0/day-one" element={<FourDayOne />} />
            <Route path="/4.0/day-two" element={<FourDayTwo />} />
            <Route path="/4.0/day-three" element={<FourDayThree />} />
            <Route path="*" element={<NotFound version="4.0" />} />
          </Route>
          <Route element={<LayoutThree />}>
            <Route path="/3.0" element={<Home />} />
            <Route path="/3.0/day-one" element={<DayOne />} />
            <Route path="/3.0/day-two" element={<DayTwo />} />
            <Route path="/3.0/day-three" element={<DayThree />} />
            <Route path="*" element={<NotFound version="3.0" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
